module.exports = __webpack_public_path__ + "static/media/whatsapp-verde.06e5b1c8.svg";